(function(algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Search result',
    search: 'Aktuelle Suche',
    allProducts: 'Alle Produkte anzeigen ',
    matching: '',
    sortBy: 'Sortieren nach',
    relevance: 'Relevanz',
    outOf: 'Nicht Verfügbar',
    resultsFound: 'Suchergebnissen für',
    oneResultFound: 'Ein Ergebnis gefunden',
    noResultFound: 'Keine Ergebnisse gefunden',
    addToCart: 'In den Warenkorb legen',
    searchForProduct: 'Suche nach Produkte',
    selectedFilter: 'Ausgewählte Filter',
    clearAll: 'Alles löschen',
    outOfStock: 'Nicht verfügbar',
    products: 'Produkte',
    collections: 'Kollektionen',
    articles: 'Blog Artikel',
    pages: 'Seiten',
    try: 'Try',
    clearFilters: 'löschung der Filter',
    or: 'oder',
    changeInput: 'ihre Eingaben ändern',
    showLess: 'Weniger anzeigen',
    showMore:'Mehr anzeigen'
  };

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return 'No result for " ' + text + ' ".';
    },
    in: function(processingTimeMS) {
      return 'in ' + processingTimeMS / 1000 + 's';
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ' out of'
      );
    },

    by: function(text) {
      if (!text) return '';
      return ' by ' + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliaShopify);
